import '../../../../../assets/css/order_details.css';
import React, { useEffect, useState, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import swal from 'sweetalert';
import Button from '@mui/material/Button';
import Form from 'react-bootstrap/Form'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import { pdf } from '@react-pdf/renderer';
import empty from '../../../../empty.jpg'
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';



import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../../../loading_animation_view/loading_animation_view';
import { service_confirm_with_supplier, get_order_infos_for_file, service_change_order_state, save_purchase_infos } from '../../../../../services/purchase_service';
import { get_categories_forAll_services, add_SelectedSupplier_to_purchase_request, requester_change_order_state } from '../../../../../services/for_allServices';
import Set_refuse_reason from './set_refuse_reason/set_refuse_reason';
import Order_form_header_pdf from './order_form_pdf/order_form_header_pdf';
import Delivery_supposed_date_modal_from_supplier_to_intern from './Delivery_supposed_date_modal_to_intern_from_supplier/delivery_supposed_date_modal_from_supplier_to_intern';
import { change_order_state_depend_on_purchase_request } from "../../../../../services/supplier_service";


const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const columns = [
  { id: 'product', label: "Produit", minWidth: 0, align: 'left' },
  { id: 'unit_amount', label: "Prix unitaire (MAD)", minWidth: 0, align: 'left' },
  { id: 'product_promo', label: "Promo (%)", minWidth: 0, align: 'left' },
  { id: 'count', label: "Quantité", minWidth: 0, align: 'left' },
  { id: 'amount', label: "Prix total (MAD)", minWidth: 0, align: 'left' }
];


function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function Products({ categories, products, set_price_by_unit, set_amount_by_unit, set_promo_by_unit, disable_updates }) {


  function getCategorieById(id) {
    var categorie = "";
    categories.map((catg) => {
      if (catg.id_category === id) categorie = catg.name;
    })
    return categorie;
  }

  return (
    <>
      {
        products.map((product, id) => (
          <TableRow key={"product_col" + id}>
            <TableCell align="left">
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className='product_cell_img_container'>
                  <img src={product.product_pics.length !== 0 && product.product_pics[0] != "" ? `data:image/png;base64,${product.product_pics[0]}` : empty} />
                </span>
                <span className='product_cell_title_container'>
                  <span id="title">{product.title}</span>
                  <div className='product_cell_categorie_container'>
                    <span>Famille d'achat : </span>{getCategorieById(product.id_category)}
                  </div>
                </span>
              </div>

            </TableCell>
            <TableCell align="left">
              <Form.Control
                className="amount_container"
                autoComplete="new-password"
                type="number"
                placeholder='0'
                value={product.product_price}
                onChange={(e) => set_price_by_unit(e.target.value, id)}
                readOnly={disable_updates}
              />
            </TableCell>
            <TableCell align="center">
              <Form.Control
                className="amount_container"
                autoComplete="new-password"
                type="number"
                placeholder='0'
                value={product.product_promo}
                onChange={(e) => set_promo_by_unit(e.target.value, id)}
                readOnly
              />
            </TableCell>
            <TableCell align="center">
              <Form.Control
                className="amount_container"
                autoComplete="new-password"
                type="number"
                value={product.product_amount}
                onChange={(e) => set_amount_by_unit(e.target.value, id)}
                readOnly={disable_updates}
              />
            </TableCell>
            <TableCell align="left">
              <Form.Control
                className="amount_container"
                autoComplete="new-password"
                type="number"
                value={
                  (
                    product.product_price !== '' && !isNaN(product.product_price)
                      ? (product.product_amount * (product.product_price - ((product.product_promo !== '' && !isNaN(product.product_promo)) ? (product.product_price * product.product_promo) / 100 : 0)))
                      : 0
                  )
                }
                readOnly
              />
            </TableCell>
          </TableRow>
        ))
      }
    </>
  );
}



function Order_details({ selected_products_details, request_code, id_supplier, products_bysupplier, setProducts_bysupplier,
  order_key, order_number, request_order_validation, able_to_process_order, reverify_request_order_validation }) {

  let service = JSON.parse(localStorage.getItem('user-info'))
  const id_service = service.id;

  const classes = useStyles();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState(null);

  const [total_ht, setTotal_ht] = useState(0);
  const [vat, setvat] = useState(20);
  const [total_ttc, setTotal_ttc] = useState(0);
  const [shippingCosts, setshippingCosts] = useState(0);
  const [discount, setdiscount] = useState(0);

  const [disable_updates, setDisable_updates] = useState(false);

  const [order_state, setOrder_state] = useState(null);
  const [open_reason_modal, setOpen_reason_modal] = useState(null);

  const [able_to_process_order_tmp, setAble_to_process_order_tmp] = useState(able_to_process_order);

  const [wait_submitting, setWait_submitting] = useState(false);
  const [openDateDialog, setOpenDateDialog] = useState(false);


  useEffect(() => {


    console.log("l", selected_products_details);

    get_categories_forAll_services().then((response) => {
      setCategories(response.data);
    }).catch((error) => {
      //console.log(error.response);
    });

    //console.log(selected_products_details.vat);
    async function set_vat_value(val) {
      setvat(val);
    }
    async function set_shipping_value(val) {
      setshippingCosts(val);
    }
    async function set_discount_value(val) {
      setdiscount(val);
    }
    async function set_products_value(vat, shippingCosts, discount, val) {
      setProducts(val);
      set_total_amountHT(vat, shippingCosts, discount, val);
    }

    setOrder_state(selected_products_details.order_state ? selected_products_details.order_state : "null");

    // if (able_to_process_order) {
    setDisable_updates(selected_products_details.order_state == "demander à être changée" ? false : selected_products_details.order_state ?
      selected_products_details.order_state !== null && selected_products_details.order_state !== "refusée"
        && selected_products_details.order_state !== "sous réserve de validation" && selected_products_details.order_state !== "refus de validation"
        ? true : false : false);
    //} else setDisable_updates(able_to_process_order);


    set_vat_value(selected_products_details.vat ?? vat);
    set_shipping_value(selected_products_details.shippingCosts);
    set_discount_value(selected_products_details.discount);
    set_products_value(selected_products_details.vat, selected_products_details.shippingCosts, selected_products_details.discount, selected_products_details.products);

  }, [selected_products_details.order_state]);


  function set_amount_by_unit(amount, id) {
    let tmp_array = [...products];
    tmp_array[id].product_amount = amount < 0 ? 0 : parseInt(amount);
    setProducts(tmp_array);
    set_total_amountHT(vat, shippingCosts, discount, tmp_array)
  }


  function set_price_by_unit(price, id) {
    let tmp_array = [...products];
    tmp_array[id].product_price = price < 0 ? 0 : parseInt(price);
    setProducts(tmp_array);
    set_total_amountHT(vat, shippingCosts, discount, tmp_array)
  }

  function set_promo_by_unit(promo, id) {
    let tmp_array = [...products];
    tmp_array[id].product_promo = promo < 0 ? 0 : parseInt(promo);
    setProducts(tmp_array);
    set_total_amountHT(vat, shippingCosts, discount, tmp_array)
  }

  async function set_total_amountHT(vat, shippingCosts, discount, products) {
    let tmp_total = 0;
    products.map((product) => {
      tmp_total += (product.product_price !== '' && !isNaN(product.product_price) ? (product.product_amount * (product.product_price - ((product.product_promo !== '' && !isNaN(product.product_promo)) ? (product.product_price * product.product_promo) / 100 : 0))) : 0);
    });
    setTotal_ht(tmp_total);
    set_total_amountTTC(vat, shippingCosts, discount, tmp_total)

  }


  async function set_total_amountTTC(vat, shippingCosts, discount, total_ht) {
    setvat(vat < 0 ? 0 : parseInt(vat));
    setshippingCosts(shippingCosts < 0 ? 0 : parseInt(shippingCosts));
    setdiscount(discount < 0 ? 0 : parseInt(discount));
    let tmp_vat = ((total_ht * (vat !== "" && !isNaN(vat) ? vat : 0)) / 100);
    let tmp_shippingCosts = ((total_ht * (shippingCosts !== "" && !isNaN(shippingCosts) ? shippingCosts : 0)) / 100);
    let tmp_discount = ((total_ht * (discount !== "" && !isNaN(discount) ? discount : 0)) / 100);
    let tmp_total = total_ht + tmp_vat + tmp_shippingCosts - tmp_discount;
    setTotal_ttc(tmp_total.toFixed(2));
  }

  async function notify_supplier(order_details) {
    console.log(order_details);
    let products_tmp = [];
    products.map((product) => {
      if (product.product_amount != 0) {
        products_tmp.push({
          "product_code": product.product_code,
          "title": product.title,
          "product_promo": !isNaN(product.product_promo) ? product.product_promo : 0,
          "product_price": !isNaN(product.product_price) ? product.product_price : 0,
          "product_amount": !isNaN(product.product_amount) ? product.product_amount : 0,
        })
      }
    });
    let order_infos = {
      "products": products_tmp,
      "discount": !isNaN(discount) ? discount : 0,
      "shippingCosts": !isNaN(shippingCosts) ? shippingCosts : 0,
      "vat": !isNaN(vat) ? vat : 0,
      "total_ht": !isNaN(total_ht) ? total_ht : 0,
      "total_ttc": !isNaN(total_ttc) ? total_ttc : 0
    }
    setWait_submitting(true);
    var order_data = null;
    let formData2 = new FormData();
    formData2.append('request_code', request_code);
    formData2.append('id_supplier', id_supplier);
    await get_order_infos_for_file(formData2).then((response) => {
      order_data = response.data;
      order_data['order_number'] = order_details.order_number ?? order_data.request_infos.order_number;
      order_data['products'] = order_infos["products"];
      order_data['total_ht'] = !isNaN(total_ht) ? total_ht : 0;
      order_data['vat'] = order_infos["vat"];
      order_data['total_ttc'] = !isNaN(total_ttc) ? total_ttc : 0;
      order_data['shippingCosts'] = order_infos["shippingCosts"];
      order_data['discount'] = order_infos["discount"];
    }).catch((error) => {
      //console.log(error.response);
    });

    console.log(order_data);
    const blob = await pdf((
      <Order_form_header_pdf order_data={order_data} />
    )).toBlob();

    let formData = new FormData();
    formData.append('request_code', request_code);
    formData.append('order_id', order_details.order_id);
    formData.append('id_supplier', products[0].id_supplier);
    formData.append('order_blob', blob);
    formData.append('order_number', order_data['order_number']);
    formData.append('products', JSON.stringify(order_infos));
    await add_SelectedSupplier_to_purchase_request(formData).then(async (response) => {
      console.log(response.data);
      const able = await reverify_request_order_validation(response.data.id);
      if(able==true){
        let tmp_products = { ...products_bysupplier };
        tmp_products[order_key].order_state = "fournisseur notifié";
        setProducts_bysupplier(tmp_products);
      }
      console.log(able);
      setAble_to_process_order_tmp(able);
      setWait_submitting(false);
      swal("Votre réponse a été enregistrée avec succès !", {
        icon: "success",
      });
    }).catch((error) => {
      console.log(error.response);
      setWait_submitting(false);
    })
  }

  async function save_purchase_infos_func(order_details) {
    console.log(order_details);
    let products_tmp = [];
    products.map((product) => {
      if (product.product_amount != 0) {
        products_tmp.push({
          "product_code": product.product_code,
          "title": product.title,
          "product_promo": !isNaN(product.product_promo) ? product.product_promo : 0,
          "product_price": !isNaN(product.product_price) ? product.product_price : 0,
          "product_amount": !isNaN(product.product_amount) ? product.product_amount : 0,
        })
      }
    });
    let order_infos = {
      "products": products_tmp,
      "discount": !isNaN(discount) ? discount : 0,
      "shippingCosts": !isNaN(shippingCosts) ? shippingCosts : 0,
      "vat": !isNaN(vat) ? vat : 0,
      "total_ht": !isNaN(total_ht) ? total_ht : 0,
      "total_ttc": !isNaN(total_ttc) ? total_ttc : 0
    }
    setWait_submitting(true);
    var order_data = null;
    let formData2 = new FormData();
    formData2.append('request_code', request_code);
    formData2.append('id_supplier', id_supplier);
    await get_order_infos_for_file(formData2).then((response) => {
      order_data = response.data;
      order_data['order_number'] = order_details.order_number ?? order_data.request_infos.order_number;
      order_data['products'] = order_infos["products"];
      order_data['total_ht'] = !isNaN(total_ht) ? total_ht : 0;
      order_data['vat'] = order_infos["vat"];
      order_data['total_ttc'] = !isNaN(total_ttc) ? total_ttc : 0;
      order_data['shippingCosts'] = order_infos["shippingCosts"];
      order_data['discount'] = order_infos["discount"];
    }).catch((error) => {
      //console.log(error.response);
    });

    console.log(order_data);
    const blob = await pdf((
      <Order_form_header_pdf order_data={order_data} />
    )).toBlob();

    let formData = new FormData();
    formData.append('request_code', request_code);
    formData.append('order_id', order_details.order_id);
    formData.append('id_supplier', products[0].id_supplier);
    formData.append('order_blob', blob);
    formData.append('order_number', order_data['order_number']);
    formData.append('products', JSON.stringify(order_infos));
    save_purchase_infos(formData).then(async (response) => {
      console.log(response.data);
      swal("votre réponse a été enregistrée avec succès !", {
        icon: "success",
      });
      setWait_submitting(false);
    }).catch((error) => {
      console.log(error);
      setWait_submitting(false);
    })
  }


  function accept_supplier_request(order_details, id_supplier, order_number) {
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          async function sendit() {
            setWait_submitting(true);
            var order_data = null;
            let products_tmp = [];
            products.map((product) => {
              products_tmp.push({
                "product_code": product.product_code,
                "title": product.title,
                "product_promo": !isNaN(product.product_promo) ? product.product_promo : 0,
                "product_price": !isNaN(product.product_price) ? product.product_price : 0,
                "product_amount": !isNaN(product.product_amount) ? product.product_amount : 0,
              })
            });
            let order_infos = {
              "products": products_tmp,
              "discount": !isNaN(discount) ? discount : 0,
              "shippingCosts": !isNaN(shippingCosts) ? shippingCosts : 0,
              "vat": !isNaN(vat) ? vat : 0,
              "total_ht": !isNaN(total_ht) ? total_ht : 0,
              "total_ttc": !isNaN(total_ttc) ? total_ttc : 0
            }
            let formData2 = new FormData();
            formData2.append('request_code', request_code);
            formData2.append('id_supplier', id_supplier);
            await get_order_infos_for_file(formData2).then((response) => {
              order_data = response.data;
              order_data['order_number'] = order_data.request_infos.order_number;
              order_data['products'] = order_infos["products"];
              order_data['total_ht'] = !isNaN(total_ht) ? total_ht : 0;
              order_data['vat'] = order_infos["vat"];
              order_data['total_ttc'] = !isNaN(total_ttc) ? total_ttc : 0;
              order_data['shippingCosts'] = order_infos["shippingCosts"];
              order_data['discount'] = order_infos["discount"];
            }).catch((error) => {
              //console.log(error.response);
            });

            const blob = await pdf((
              <Order_form_header_pdf order_data={order_data} />
            )).toBlob();

            let formData = new FormData();
            formData.append('request_code', request_code);
            formData.append('order_id', order_details.order_id);
            formData.append('id_supplier', id_supplier);
            formData.append('id_service', service.id);
            formData.append('products', JSON.stringify(order_infos));
            formData.append('accord', true);
            formData.append('order_blob', blob);
            formData.append('order_number', order_data['order_number']);
            service_confirm_with_supplier(formData).then(async (response) => {
              //console.log(response.data);
              setOrder_state("acceptée");
              let tmp_products = { ...products_bysupplier };
              tmp_products[order_key].service_accord = true;
              tmp_products[order_key].order_state = "acceptée";
              const able = await reverify_request_order_validation(order_details.order_id);
              setAble_to_process_order_tmp(able);
              swal("votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !", {
                icon: "success",
              });
              setWait_submitting(false);
              setProducts_bysupplier(tmp_products);
            }).catch((error) => {
              //console.log(error.response);
              setWait_submitting(false);
            })
          }
          sendit();
        }
      });

  }


  function refuse_supplier_request(order_details, id_supplier) {
    let formData = new FormData();
    formData.append('request_code', request_code);
    formData.append('id_supplier', id_supplier);
    formData.append('order_id', order_details.order_id);
    formData.append('id_service', service.id);
    formData.append('accord', false);
    setOpen_reason_modal(formData);
  }

  function unable_to_notify_supplier(products) {
    let unable = true;
    for (let pr of products) {
      if (pr.product_amount != 0) {
        unable = false;
        break; // Stop checking once we find a non-zero amount
      }
    }
    return unable;
  }

  function well_received(order_details, id_supplier, request_code) {
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          setWait_submitting(true);
          let formData = new FormData();
          formData.append('id_supplier', id_supplier);
          formData.append('order_id', order_details.order_id);
          formData.append('request_code', request_code);
          formData.append('state', "reçu");
          service_change_order_state(formData).then((response) => {
            //console.log(response.data);
            // setOrder_state("bien reçu");
            const tmp_order_state = response.data.order_state;
            let tmp_products = { ...products_bysupplier };
            tmp_products[order_key].order_state = tmp_order_state;
            setProducts_bysupplier(tmp_products);
            setWait_submitting(false);
            swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
              icon: "success",
            });
          }).catch((error) => {
            //console.log(error.response);
            setWait_submitting(false);
          })
        }
      });
  }


  function order_conforme(order_details, id_supplier, request_code) {
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          setWait_submitting(true);
          let formData = new FormData();
          formData.append('id_supplier', id_supplier);
          formData.append('order_id', order_details.order_id);
          formData.append('request_code', request_code);
          formData.append('state', "conforme");
          formData.append('performed_by', id_service)
          service_change_order_state(formData).then((response) => {
            //console.log(response.data);
            //setOrder_state("conforme");
            const tmp_order_state = response.data.order_state;
            let tmp_products = { ...products_bysupplier };
            tmp_products[order_key].order_state = tmp_order_state;
            setProducts_bysupplier(tmp_products);
            setWait_submitting(false);
            swal("votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !", {
              icon: "success",
            });
          }).catch((error) => {
            //console.log(error.response);
            setWait_submitting(false);
          })
        }
      });
  }


  function order_no_conforme(order_details, id_supplier, request_code) {
    let formData = new FormData();
    formData.append('id_supplier', id_supplier);
    formData.append('order_id', order_details.order_id);
    formData.append('request_code', request_code);
    formData.append('state', "non conforme");
    formData.append('id', order_key);
    setOpen_reason_modal(formData);
  }

  const handleDelivery = () => {
    setOpenDateDialog(true);
  };

  function cancel_order(order_details, id_supplier, request_code) {
    console.log(order_details);
    let formData = new FormData();
    formData.append('id', order_key);
    formData.append('cancel_order', true);
    formData.append('request_code', request_code);
    formData.append('state', "annulée");
    formData.append('order_id', order_details.order_id);
    formData.append('id_supplier', id_supplier);
    formData.append('id_service', service.id);
    formData.append('accord', false);
    setOpen_reason_modal(formData);
  }

  const update_able_to_ = useMemo(() => {
    console.log("able_to_process_order", able_to_process_order)
    setAble_to_process_order_tmp(able_to_process_order);
  }, [able_to_process_order])


  //service achat

  //////////////////////
  /////////////////////////////////////////////////////////
  ///////////////////////////////////

  return (
    <>
      {
        products === null
          ? <Loading_animation_view />
          : <div className="order_plus_details_container">
            <TableContainer className="order_plus_details_table_container">
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    {
                      columns.map((column) => (
                        <TableCell key={column.id} align={column.align}>{column.label}</TableCell>
                      ))
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    selected_products_details.length !== 0
                      ?
                      <>
                        <Products categories={categories} products={products} set_price_by_unit={set_price_by_unit} set_amount_by_unit={set_amount_by_unit} set_promo_by_unit={set_promo_by_unit} disable_updates={disable_updates} />
                      </>

                      : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun produit disponible</div>
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <div className='total_amount_container'>
              <TableContainer className="total_amount_table_container">
                <Table className={classes.table}>
                  <TableBody>
                    <TableRow>
                      <TableCell align={"left"}>Total HT (MAD)</TableCell>
                      <TableCell align={"right"}>{numberWithSpaces(total_ht) + " MAD"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align={"left"}>Taux de TVA (%)</TableCell>
                      <TableCell align={"right"}>
                        <Form.Control
                          className="amount_container"
                          autoComplete="new-password"
                          type="number"
                          placeholder='0'
                          value={vat}
                          onChange={(e) => { set_total_amountTTC(e.target.value, shippingCosts, discount, total_ht); }}
                          readOnly={disable_updates}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align={"left"}>Frais d’expédition (%)</TableCell>
                      <TableCell align={"right"}>
                        <Form.Control
                          className="amount_container"
                          autoComplete="new-password"
                          type="number"
                          placeholder='0'
                          value={shippingCosts}
                          onChange={(e) => { set_total_amountTTC(vat, e.target.value, discount, total_ht); }}
                          readOnly
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align={"left"}>Remise (%)</TableCell>
                      <TableCell align={"right"}>
                        <Form.Control
                          className="amount_container"
                          autoComplete="new-password"
                          type="number"
                          placeholder='0'
                          value={discount}
                          onChange={(e) => { set_total_amountTTC(vat, shippingCosts, e.target.value, total_ht); }}
                          readOnly={disable_updates}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align={"left"}>Total TTC (MAD)</TableCell>
                      <TableCell align={"right"}>{numberWithSpaces(total_ttc) + " MAD"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="proceed_button_container">
              <>
                {
                  able_to_process_order_tmp == true || ["annulée"].includes(order_state)
                    ? <>
                      {
                        order_state !== null
                          ? <>
                            {
                              order_state === "sous réserve de validation"
                                ? <>
                                  <Button variant="contained" className={wait_submitting ? "submit_but cancel_but disabled_button" : "submit_but cancel_but"} onClick={() => refuse_supplier_request(selected_products_details, id_supplier)}>
                                    Refuser
                                  </Button>
                                  <Button variant="contained" className={wait_submitting ? "submit_but valide_but disabled_button" : "submit_but valide_but"} onClick={() => accept_supplier_request(selected_products_details, id_supplier, order_number)}>
                                    Valider
                                  </Button>
                                </>
                                : <>
                                  {
                                    order_state === "null" || order_state == "demander à être changée"
                                      ? <>
                                        {/* <Button variant="contained" className={wait_submitting ? "submit_but cancel_but disabled_button" : "cancel_but submit_but"}
                                          onClick={() => {console.log(selected_products_details);cancel_order(selected_products_details, id_supplier, request_code)}} >
                                          Annuler
                                        </Button> */}
                                        <Button variant="contained" className={wait_submitting || unable_to_notify_supplier(products) ? "submit_but disabled_button" : "submit_but"} endIcon={<NavigateNextIcon className="my_icon" />}
                                          onClick={() => notify_supplier(selected_products_details)} >
                                          Notifier le fournisseur
                                        </Button>
                                      </>
                                      : <>
                                        {
                                          order_state !== "annulée" && order_state !== "conforme" && order_state!=="En cours de livraison (interne)" && order_state !== "conforme en attente de livraison" && !order_state.includes("facture") && order_state !== "reçu"
                                            ? <>
                                              {
                                                order_state !== "reçu externe"
                                                  // ? <Button variant="contained" className={wait_submitting || !(order_state === "acceptée" || order_state === "en cours de livraison") ? "submit_but valide_but disabled_button" : "submit_but valide_but"}
                                                  ? <Button variant="contained" className={wait_submitting ? "submit_but valide_but disabled_button" : "submit_but valide_but"}
                                                    startIcon={<DoneIcon className="my_icon" />} onClick={() => well_received(selected_products_details, id_supplier, request_code)}>
                                                    recevoir la commande
                                                  </Button>
                                                  : <>
                                                    <Button variant="contained" className={wait_submitting || products.length === 0 ? "submit_but cancel_but disabled_button" : "submit_but cancel_but"}
                                                      startIcon={<RemoveDoneIcon className="my_icon" />} onClick={() => order_no_conforme(selected_products_details, id_supplier, request_code)}    >
                                                      Commande non conforme
                                                    </Button>
                                                    <Button variant="contained" className={wait_submitting || products.length === 0 ? "submit_but valide_but disabled_button" : "submit_but valide_but"}
                                                      startIcon={<DoneAllIcon className="my_icon" />} onClick={() => order_conforme(selected_products_details, id_supplier, request_code)}  >
                                                      Commande conforme
                                                    </Button>
                                                  </>
                                              }
                                            </>
                                            : <></>
                                        }{
                                          order_state === "conforme en attente de livraison" ?
                                            <Button
                                              variant="contained"
                                              className="submit_but valide_but"
                                              startIcon={<LocalShippingTwoToneIcon className="my_icon" />}
                                              onClick={() => handleDelivery(selected_products_details)}
                                            >
                                              Livrer
                                            </Button>
                                            : <></>
                                        }
                                      </>
                                  }
                                </>
                            }
                          </>
                          : <></>
                      }
                    </>
                    : <>
                      <Button variant="contained" className={wait_submitting ? "submit_but cancel_but disabled_button" : "cancel_but submit_but"}
                        onClick={() => cancel_order(selected_products_details, id_supplier, request_code)} >
                        Annuler
                      </Button>
                      <Button variant="contained" className={wait_submitting || unable_to_notify_supplier(products) ? "submit_but valide_but disabled_button" : "submit_but valide_but"}
                        onClick={() => save_purchase_infos_func(selected_products_details)} >
                        Sauvegarder
                      </Button>
                    </>
                }
              </>
            </div>
          </div>
      }
      {
        open_reason_modal !== null
          ? <Set_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal}
            products_bysupplier={products_bysupplier} setProducts_bysupplier={setProducts_bysupplier} />
          : <></>
      }

      {openDateDialog &&
        <Delivery_supposed_date_modal_from_supplier_to_intern
          open_deliveryDate_modal={openDateDialog}
          selected_products_details={selected_products_details}
          setOpen_deliveryDate_modal={setOpenDateDialog}
          request_code={request_code} setWait_submitting={setWait_submitting}
          id_supplier={id_supplier}
          setOrder_state={setOrder_state}
        />}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait_submitting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default Order_details;
